export default "__VITE_ASSET__275e2332__"